var _ = require('underscore');
var Entities = require('Entities');
var Labels = EY.Consultation.Labels;
var StatusType = EY.Consultation.Lookups.StatusType;
var User = EY.Consultation.CurrentUser;

var filterRoles = function(userRoles) {
    var filteredRoles = userRoles.replace(Labels.Role_AreaAdministrator, '')
        .replace(Labels.Role_RegionAdministrator, '')        
        .replace(Labels.Role_UsRegionReviewer, '')
        .replace(Labels.Role_Reviewer, '')
        .replace(/^,|,$/g,'')
        .split(','); 
    
    var displayRoles = filteredRoles.filter(function (el) {
        return el != ' ';
    });
    var filteredRolesToShow = displayRoles.toString().trim();
    return filteredRolesToShow;
}

var role = function (options) {
    var record = options.record;
    var approverGroup = record.get('approverGroupId');
    var group = approverGroup ? Labels['ApproverGroup_' + approverGroup] : '';
    var me = record.get('assignedTo') === User.upn;
    var myrole;
    var rolesToShow = filterRoles(User.rolenames);
    var status = record.get('statusTypeId');
    if (!me) {
        var myGroup = _.last(record.get('whoami').split('|'));
        var notifiedUser = status === StatusType.UsersNotified && myGroup === 'RequiredNotification';
        myrole = notifiedUser ? Labels["ApproverGroup_RequiredNotification_Role"] : rolesToShow;
    }
    return me ? (group || (/StatusType_Preparation/.test(status) ? Labels.Role_Reviewer : Labels.Creator)) : myrole;
};

module.exports.log = function (options) {
    var activities = options.activities;
    var record = options.record;
    var text = options.text;
    var firstApprover = record.get('assignedTo') === User.upn && record.get('createdBy') === User.upn && options.action && options.action === 'submit';

    if (text && !/StatusType_Blank|StatusType_Draft/.test(record.get('statusTypeId')) && !firstApprover) {
        activities.add(new Entities.Activity({
            givenName: User.givenName,
            role: role(options),
            order: _.now(),
            text: text,
            date: new Date()
        }));
    }
};


// WEBPACK FOOTER //
// ./js/Modules/Record/Service/RecordActivityLog.js